export enum UserActionTypePageVisited {
  CalendarVisited = 'CalendarVisited',
  ContactsVisited = 'ContactsVisited',
  DriveVisited = 'DriveVisited',
  MailVisited = 'MailVisited',
  SharePointVisited = 'SharePointVisited',
  TeamDrivesVisited = 'TeamDrivesVisited'
}
